<template>
  <div class="p-3">
    <b-row>
      <b-col cols="2">
        <div class="sg-badge" :class="getActiveSetting('on_going')" @click="showOnGoingOrder">
          <font-awesome-icon icon="calendar-check" /> On Going
        </div>
      </b-col>

      <b-col cols="2">
        <div class="sg-badge" :class="getActiveSetting('history')" @click="showHistoryOrder">
          <font-awesome-icon icon="history" /> History
        </div>
      </b-col>
    </b-row>

    <b-row class="p-3">
      <b-table
          hover
          striped
          show-empty
          stacked="md"

          :items="activity_arr"
          :fields="activity_column"
        >
          <!-- <template v-slot:cell(actions)="row">
            <b-button v-if="(row.item.status === 'Unpaid' || row.item.status === 'Failed')" size="sm" variant="success" @click="confirmPayment(row.item)">
              <font-awesome-icon icon="upload" /> Upload Receipt
            </b-button>
            <b-button v-if="row.item.status === 'Paid'" size="sm" @click="viewReceipt(row.item)">
              <font-awesome-icon icon="pencil-alt" /> View Receipt
            </b-button>
            <b-button v-if="row.item.status === 'Pending Admin'" size="sm" disabled>
              Waiting for Admin Confirmation
            </b-button>
          </template> -->
        </b-table>
        <!-- <TableActivityOngoing v-if="activity_body === 'ongoing'" /> -->
        <!-- <TableActivityHistory v-if="activity_body === 'history'" /> -->
    </b-row>
  </div>
</template>

<script>
/* import TableActivityOngoing from '@/templates/TableActivityOngoing'
import TableActivityHistory from '@/templates/TableActivityHistory' */
import moment from 'moment'
import OrderAPI from '@/api/OrderAPI'

export default {
  name: 'MyAccount_Activity',
  components: {
    /* TableActivityOngoing,
    TableActivityHistory */
  },
  props: ['user'],
  data () {
    return {
      activity_body: '',

      activity_arr: [],
      activity_column: [
        { key: 'order_id', label: 'Order ID' },
        { key: 'start_date', label: 'Start Date' },
        { key: 'end_date', label: 'End Date' },
        { key: 'duration', label: 'Duration' },
        { key: 'guider', label: 'Guider' }
        // { key: 'actions', label: '', class: 'text-center' }
      ]
    }
  },
  created: function () {
    this.showOnGoingOrder()
  },
  methods: {
    // PREREQUISITES
    getActiveSetting (property) {
      return {
        'on': property === this.activity_body
      }
    },
    showOnGoingOrder: function () {
      this.activity_body = 'on_going'
      let status = [{status: `paid`}, {status: `on_guide`}]
      this.fetchOrderList({
        select: 'order_id start_date end_date duration guider status',
        query: {
          is_delete: false,
          customer: this.user._id,
          $or: status
        }
      })
    },
    showHistoryOrder: function () {
      this.activity_body = 'history'

      this.fetchOrderList({
        select: 'order_id start_date end_date duration guider status',
        query: {
          is_delete: false,
          customer: this.user._id,
          status: 'on_review'
        }
      })
    },
    // END PREREQUISITES

    // HTTP REQUEST
    fetchOrderList: async function (param) {
      try {
        const response = await OrderAPI.fetchOrderList(param)
        this.activity_arr = []

        response.data.orders.forEach(order => {
          let guider = (order.guider) ? order.guider.first_name : `Choose your Guider`
          let startdate = moment(order.start_date).startOf(`day`)
          let enddate = moment(order.end_date).startOf(`day`)
          let date = moment().startOf(`day`)
          let calculatedays
          if (startdate > date) {
            calculatedays = enddate.diff(startdate, 'days')
          } else {
            calculatedays = enddate.diff(date, 'days')
          }
          let guiderduration = (order.status === `on_guide`) ? `${calculatedays} day(s) left` : (order.status === `paid` || order.status === `on_review` || order.status === `done`) ? `${order.duration} day(s)` : `-`
          if (calculatedays === 0) {
            guiderduration = `Last day :(`
          } else if (calculatedays < 0) {
            guiderduration = `Thank You for Reviewing our Guider :)`
          }

          this.activity_arr.push({
            _id: order._id,
            order_id: order.order_id,
            start_date: moment(order.start_date).format(`ll`),
            end_date: moment(order.end_date).format(`ll`),
            duration: `${guiderduration}`,
            guider
          })
        })
      } catch (error) {
        console.log(error)
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-badge {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/Activity/Activity.vue